import React from "react";
import PT from "prop-types";
import get from "lodash/get";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";
import { HeroImage } from "../../../atoms/HeroImage";
import StoryDetails from "../gn-story-template/StoryDetails";

import "./head-line-first.m.css";

const HeadlineFirstLayout = ({ story }) => {
  const deviceType = useDeviceType();
  const heroImageSlug = get(story, ["hero-image-s3-key"], "");
  const isMobile = deviceType === "mobile";
  return (
    <>
      {!isMobile ? (
        <div styleName="gn-top-div">
          <StoryDetails story={story} />
          {heroImageSlug && <HeroImage story={story} aspectRatio={[[16, 9]]} isStoryPageImage />}
        </div>
      ) : (
        <>
          <div styleName="gn-top-div">
            <StoryDetails story={story} />
          </div>
          <div>{heroImageSlug && <HeroImage story={story} aspectRatio={[[16, 9]]} isStoryPageImage />}</div>
        </>
      )}
    </>
  );
};

HeadlineFirstLayout.propTypes = {
  story: PT.object,
};

export default HeadlineFirstLayout;
